import {
  takeLatest, call, put, cancel, SagaReturnType,
} from 'redux-saga/effects';

import * as request from 'app/lib/provider/request';

import Analytics from 'app/lib/Analytics/Analytics';
import { select } from 'app/store/utils/saga/effects';
import { IPageGift } from 'app/store/nodes/card/interfaces';
import * as cardStore from 'app/store/nodes/card';
import * as giftActions from '../actions';

export const config = {
  action: giftActions.useGift.type,
  method: takeLatest,
};

export function* func(action: giftActions.IEmptyPayload) {
  Analytics.track().useGiftMethodTriggered();
  const page = yield* select((state) => state?.card?.pages[state?.flipbook?.currentPage] as IPageGift);
  const uuid = yield* select((state) => state?.card?.common.uuid);
  const identity = yield* select((state) => state.card?.common?.identity);
  const { type, param, code } = identity;

  if (!type || !param || !code || !uuid) {
    yield cancel(); return;
  }

  if (page?.type !== 'PageGift') {
    Analytics.track().useGiftMethodNoGiftCard();
    yield cancel(); return;
  }

  yield put(giftActions.setLoadingGift());
  const gift = page?.items?.gift;

  if (gift?.link) {
    Analytics.track().useGiftMethodShortLinkDoesntExist();
    yield put(giftActions.useGiftSuccess(gift?.link));
    yield cancel(); return;
  }

  Analytics.track().useGiftMethodShortLinkDoesntExist();
  let link;

  try {
    const response: SagaReturnType<typeof request.redeem> = yield call(() => request.redeem(uuid));
    const { data, error } = response;
    if (error || data?.error || !data?.link) {
      throw error || data?.error || new Error('Empty short link');
    }
    link = data.link;
    if (!!link && gift?.type === 'physical') {
      yield put(cardStore.actions.setPhysicalGiftOpened());
    }
    yield put(giftActions.useGiftSuccess(link));
  } catch (error) {
    console.error(error);
    yield put(giftActions.useGiftError());
    yield cancel();
  }
}
